import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter } from 'react-router-dom';
import { store, persistor } from './redux/store';
import {showLoading, hideLoading} from './utils/utils';

import App from './App';


ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <PersistGate persistor={persistor}>
        <App hideLoading={hideLoading} showLoading={showLoading} />
      </PersistGate>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);


